import { getI18nInstance } from "@/utils/i18n";
import { formatBytes } from "@/utils/miscellaneous";
import { hasFreeOperations } from "@/utils/accessControl";
import { getFileExtension } from "@/utils/files";
import ExceededConversionError from "@/errors/ExceededConversionError";
import ValidationError from "@/errors/ValidationError";

/**
 * Maximum file size allowed (in bytes).
 */
export const MAX_FILE_SIZE_BYTES = 10485760; // 10MB

/**
 * Sets maximum free compression number for a user per day.
 * Allowed values:
 *  - null or negative integer number: unlimited conversions
 *  - positive integer number: specific conversions limit
 */
export const MAX_FREE_COMPRESSION_PER_DAY = 5;

const ALLOWED_FILE_EXTENSIONS = ["pdf"];

export function validateInputFile(file: File) {
  const i18n = getI18nInstance();

  if (!hasFreeOperations("compression")) {
    throw new ExceededConversionError(
      i18n.translate("pdfextra_convert_tool.errors.max_free_conversions", {
        MAX_FREE_CONVERSION_PER_DAY: Number(
          MAX_FREE_COMPRESSION_PER_DAY
        ).toString(),
      })
    );
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new ValidationError(
      i18n.translate("pdfextra_convert_tool.errors.file_too_large", {
        MAX_FILE_SIZE: formatBytes(MAX_FILE_SIZE_BYTES),
      })
    );
  }

  const extension = getFileExtension(file.type);

  if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
    throw new ValidationError(
      i18n.translate("pdfextra_convert_tool.errors.not_supported_file_format", {
        allowedExtensions: ALLOWED_FILE_EXTENSIONS.join(", "),
      })
    );
  }
}
